import glamorous from "glamorous"
import style from "utils/style"

const Input = glamorous.input({
  width: "90%",
  margin: "5px auto 5px auto",
  padding: 10,
  borderRadius: 5,
  border: `1px solid ${style.colors.stoneGray}`,
  fontSize: 16,
})

export default Input



// WEBPACK FOOTER //
// ./src/elements/Input.js